<ngx-spinner [name]="'solicitacoes-exclusao-dados'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Solicitações exclusão de dados</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>
        <div class="row">
            <div class="col-sm-6">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Filtro</mat-label>
                    <input matInput (keyup)="aplicarFiltroTabela($event)" placeholder="Filtro">
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-sm">
                <table mat-table [dataSource]="solicitacoesExclusaoDadosSource" class="mat-elevation-z2"
                    style="width: 100%;">

                    <ng-container matColumnDef="Nome">
                        <th mat-header-cell *matHeaderCellDef> Nome </th>
                        <td mat-cell *matCellDef="let element"> {{element.Nome}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Email">
                        <th mat-header-cell *matHeaderCellDef> Email </th>
                        <td mat-cell *matCellDef="let element"> {{element.Email}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Telefone">
                        <th mat-header-cell *matHeaderCellDef> Telefone </th>
                        <td mat-cell *matCellDef="let element"> {{element.Telefone}} </td>
                    </ng-container>

                    <ng-container matColumnDef="CPFCNPJ">
                        <th mat-header-cell *matHeaderCellDef> CPF / CNPJ </th>
                        <td mat-cell *matCellDef="let element"> {{element.CPFCNPJ}} </td>
                    </ng-container>

                    <ng-container matColumnDef="DataHoraSolicitacao">
                        <th mat-header-cell *matHeaderCellDef> Data e Hora </th>
                        <td mat-cell *matCellDef="let element"> {{element.DataHoraSolicitacao}} </td>
                    </ng-container>

                    <ng-container matColumnDef="sVisualizada">
                        <th mat-header-cell *matHeaderCellDef> Visualizada </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="retangulo_tabela"
                                [ngStyle]="{'background': (element.sVisualizada=='Sim') ? '#42D697' : '#FE696A'}">
                                {{element.sVisualizada}}</div>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="ConfirmarVisualizacao">
                        <th mat-header-cell *matHeaderCellDef> Confirmar Visualizacao </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button matTooltip="Detalhar solicitação de exclusão de dados" (click)="confirmarVisualizacao(element)"
                                class="iconbutton" color="primary">
                                <mat-icon aria-label="Expandir">check</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" >
                    </tr>

                    <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="7" style="text-align: center;">Não há solicitações no sistema ou
                            com o filtro definido
                        </td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 15, 20, 25]"></mat-paginator>
            </div>
        </div>
    </mat-card-content>

</mat-card>
